// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2481":"95cc8b295e8c2fe2","2888":"d014965e49fa4148","5078":"01cd20ddfaa5a7a3","6872":"0cc141b991121ca1","7695":"0cc141b991121ca1","9656":"95cc8b295e8c2fe2"}[chunkId] + ".css";
};